import { render, staticRenderFns } from "./impAipo.vue?vue&type=template&id=58649070"
import script from "./impAipo.vue?vue&type=script&lang=js"
export * from "./impAipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports